module.exports = __webpack_public_path__ + "img/icon-googlechrome.ae066f44.svg";